import { AuthForm } from "components/AuthForm/AuthForm";

export const SignInPage = () => {
  return <>
    <AuthForm />

  </>;
};
